import { Link, Navigate, Route, Routes } from 'react-router-dom'
import { JobListPage } from './routes/jobs/list'
import { JobDetailPage } from './routes/jobs/detail'
import { NewJobPage } from './routes/jobs/new'
import { MemoryListPage } from './routes/memories/list'

// ISSUE #10: 共通レイアウト。ヘッダーに タイトル + nav。Tailwind v4 utility のみで構成。
function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/jobs" className="text-lg font-semibold tracking-tight">
            Self-Improving Agent
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/jobs" className="text-slate-600 hover:text-slate-900">
              Jobs
            </Link>
            <Link to="/memories" className="text-slate-600 hover:text-slate-900">
              Memories
            </Link>
            <Link
              to="/jobs/new"
              className="rounded bg-slate-900 px-3 py-1.5 text-white hover:bg-slate-700"
            >
              New Job
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-8">{children}</main>
    </div>
  )
}

export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/jobs" replace />} />
        <Route path="/jobs" element={<JobListPage />} />
        <Route path="/jobs/new" element={<NewJobPage />} />
        <Route path="/jobs/:id" element={<JobDetailPage />} />
        <Route path="/memories" element={<MemoryListPage />} />
        <Route
          path="*"
          element={<p className="text-slate-500">Not found.</p>}
        />
      </Routes>
    </Layout>
  )
}
